import { useEffect } from 'react';
import classnames from 'classnames';

import { REVIEW_FORM_LS_KEY } from 'utils/constant';

import type { CompanyAnonReviewFormProps } from '../companyAnonReviewForm';
import CompanyAnonReviewForm from '../companyAnonReviewForm';

import classes from './companyAnonReviewFormPopup.module.css';

interface Props extends CompanyAnonReviewFormProps {
  show: boolean;
  onClose: () => void;
  isGlobalModal?: boolean;
}

const CompanyAnonReviewFormPopup = ({
  companyName,
  companyID,
  show,
  onClose,
  isGlobalModal = false,
  ...anonReviewFormProps
}: Props) => {
  /**
   * This popup might be localized or it might be global. The global one is controlled by
   * Redux, the local one is controlled by its parent component.
   * If the user opened a local popup, perma-block the global one.
   */
  useEffect(() => {
    if (!isGlobalModal && show) {
      localStorage.setItem(REVIEW_FORM_LS_KEY.PAGE_LAST_SEEN, window.pageCategory);
    }
  }, [isGlobalModal, show]);

  return (
    <>
      {show && (
        <>
          <div className={classnames(classes['popup-overlay'])}></div>
          <div className={classnames(classes['popup-container'], 'w-730')}>
            <CompanyAnonReviewForm
              popup
              companyName={companyName}
              companyID={+companyID}
              onPopupClose={onClose}
              {...anonReviewFormProps}
            />
          </div>
        </>
      )}
    </>
  );
};

export default CompanyAnonReviewFormPopup;
export type { Props as CompanyAnonReviewFormPopupProps };
